let ConstantsSettings = {};

// parse integer values from typoscript settings
if (typeof IgHeadersliderSettings !== "undefined") {
  for (let property in IgHeadersliderSettings) {
    if (IgHeadersliderSettings.hasOwnProperty(property)) {
      let value = IgHeadersliderSettings[property];
      if (!isNaN(value)) {
        IgHeadersliderSettings[property] = parseInt(value);
      }
    }
  }

  ConstantsSettings = IgHeadersliderSettings;
}

/**
 * Global Settings Object
 * merged with settings from flexform
 * @type object
 */
export const Settings = Object.assign({
  timeout: 5000,
  duration: 2000,
  pauseOnHover: false,
  nav: {
    dots: true,
    arrows: false
  },
  width: 2560,
  height: 894,
  breakpoint: 900
}, ConstantsSettings);
